// extracted by mini-css-extract-plugin
module.exports = {"transaction_debit":"styles_transaction_debit__1X5rq","transaction_credit":"styles_transaction_credit__1GPXG"};